import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import _ from 'lodash'
import { Calendar } from '../../api/services/next';

// Rebuilds reservation composition when extending or shortening reservation
export const RebuildReservation = (reservation, newCheckInDate, newCheckOutDate, roomId)=>{
    const start = moment(newCheckInDate).startOf("day")
    const end = moment(newCheckOutDate).endOf("day")
        
    const prevstart = moment(reservation.CheckInDate).startOf("day")
    const prevend = moment(reservation.CheckOutDate).endOf("day")
    const range = moment.range(start, end)

    // Remove any accomodations and addons outside of the range
    if (start.diff(prevstart, "days") > 0 || prevend.diff(end, "days") > 0) {
        //  We check for the same roomid since reservation could be not homogenius
        if (reservation.ReservationDailyAccommodations){
            reservation.ReservationDailyAccommodations.forEach(accomodation => {
                const date = moment(accomodation.Date).endOf("day")
                //const isInRange = date >= start && date < end
                if (roomId) {
                    accomodation.IsDeleted = accomodation.RoomId === roomId && !range.contains(date, { excludeEnd: true }) //isInRange
                } else {
                    accomodation.IsDeleted = !range.contains(date, { excludeEnd: true }) //isInRange
                }
            })
        }
        
        if (reservation.ReservationDailyAddons){
            reservation.ReservationDailyAddons.forEach(addon => {
                const date = moment(addon.Date).endOf("day")
                addon.IsDeleted = !range.contains(date, { excludeEnd: true })

            })
        }
    }

    // Add missing accomodations and addons at the BEGINNING of the reservation 
    if (prevstart.diff(start, "days") > 0) {
        const newdates = Array.from(moment.range(start, moment(prevstart).subtract(1, "day")).by("day"))
        if (reservation.ReservationDailyAccommodations) {
            const accomodation = _.first(reservation.ReservationDailyAccommodations.filter(x => !x.IsDeleted))
            if (accomodation) {
                reservation.ReservationDailyAccommodations = _.concat(_.map(newdates, date => {
                    return { ...accomodation, Date: date.toISOString(), Id: 0, FolioTransactionID: null }
                }), reservation.ReservationDailyAccommodations)
            }
        }

        if (reservation.ReservationDailyAddons) {
            const firstDay = moment(reservation.CheckInDate)
            const addons = reservation.ReservationDailyAddons.filter(x=>moment(x.Date).isSame(firstDay, "day"))
            
            if (addons.length) {
                const newAddons = []
                _.map(newdates, date => {
                    addons.forEach(addon=>{
                        newAddons.push({
                            ...addon, 
                            Date: date.toISOString(), 
                            Id: 0,
                            FolioTransactionID: null
                        })
                    })
                })
    
                reservation.ReservationDailyAddons =[...newAddons, ...reservation.ReservationDailyAddons]
            }
        }
    }

    // Add missing accomodations and addons at the END of the reservation 
    if (end.diff(prevend, "days") > 0) {
        const newdates = Array.from(moment.range(prevend, moment(end).subtract(1, "day")).by("day"))
        if (reservation.ReservationDailyAccommodations){
            const accomodation = _.last(reservation.ReservationDailyAccommodations.filter(x => !x.IsDeleted))
            if (accomodation) {
                reservation.ReservationDailyAccommodations = _.concat(reservation.ReservationDailyAccommodations,
                    _.map(newdates, date => {
                        return { ...accomodation, Date: date.startOf("day").toISOString(), Id: 0, FolioTransactionID: null }
                    }))
            }
        }

        if (reservation.ReservationDailyAddons) {
            const lastDay = moment(reservation.CheckOutDate).subtract(1,"day")
            const addons = reservation.ReservationDailyAddons.filter(x=>moment(x.Date).isSame(lastDay, "day") && !x.IsDeleted)
            if (addons.length) {
                const newAddons = []
                _.map(newdates, date => {
                    addons.forEach(addon=>{
                        newAddons.push({
                            ...addon, 
                            Date: date.toISOString(), 
                            Id: 0, 
                            FolioTransactionID: null
                        })
                    })
                })
    
                reservation.ReservationDailyAddons =[...reservation.ReservationDailyAddons, ...newAddons]
            }
        }
    }

    // Reset Addons consumption date 
    if(reservation.ReservationDailyAddons) {
        reservation.ReservationDailyAddons.forEach(addon=>{
            const IsConsumptionAfterReservationDay = addon.HotelAddon.ChainAddon.IsConsumptionAfterReservationDay
            addon.ConsumptionDate = IsConsumptionAfterReservationDay?moment(addon.Date).add(1, "day").toISOString():addon.Date
        })
    }

    reservation.CheckInDate = newCheckInDate
    reservation.CheckOutDate = newCheckOutDate
    reservation.Eta = moment(reservation.CheckInDate).format("HH:mm:ss"),
    reservation.Edt = moment(reservation.CheckOutDate).format("HH:mm:ss")
    reservation.Nights = Math.max(1, end.diff(start, "days"))
    reservation.IsDayUse = moment(reservation.CheckInDate).isSame(reservation.CheckOutDate, "day")

    // If Pricing type set to "Fixed Total" then redistribute daily accomodation price accordingly to keep the total price
    if (reservation.ReservationPricingTypeId === 3 && reservation.ReservationDailyAccommodations) {
        const addonsPriceBeforeTax = _.sumBy(reservation.ReservationDailyAddons, x=>x.IsDeleted?0:x.ComputedTotalBeforeTax)
        const addonsPriceAfterTax =_.sumBy(reservation.ReservationDailyAddons, x=>x.IsDeleted?0:x.ComputedTotalAfterTax)

        const accomodationPriceBeforeTax = reservation.TotalAmountProductCurrentBeforeTax - addonsPriceBeforeTax
        const accomodationPriceAfterTax = reservation.TotalAmountProductCurrentAfterTax - addonsPriceAfterTax
        reservation.ReservationDailyAccommodations.forEach(accomodation => {
            if (!accomodation.IsDeleted) {
                const IsBeforeTax  = accomodation.Amount === accomodation.AmountBeforeTax
                accomodation.Amount = (IsBeforeTax?accomodationPriceBeforeTax:accomodationPriceAfterTax)/reservation.Nights
                accomodation.AmountBeforeTax = accomodationPriceBeforeTax/reservation.Nights
                accomodation.AmountAfterTax = accomodationPriceAfterTax/reservation.Nights
            }
        })
    }
}

export const RecalcReservationForFixedPricesPaxChange = (reservation, paxProp, paxDelta) => {
    //calc delta in daily addons that needs to be subtracted from daily reservation
    const addondPropsBeforeTax = {
        "Adults": "AdultAmountBeforeTax",
        "Children": "ChildAmountBeforeTax",
        "Infants": "InfantAmountBeforeTax"
    }

    const addondPropsAfterTax = {
        "Adults": "AdultAmountAfterTax",
        "Children": "ChildAmountAfterTax",
        "Infants": "InfantAmountAfterTax"
    }

    const numOfAddons = reservation.ReservationDailyAddons.filter(x => !x.IsDeleted).length
    const numOfAccomodations = reservation.ReservationDailyAccommodations.filter(x => !x.IsDeleted).length
    const addonToCalcBy = reservation.ReservationDailyAddons.find(x => !x.IsDeleted)
    const addonsDeltaBeforeTax = addonToCalcBy[addondPropsBeforeTax[paxProp]] * paxDelta * numOfAddons / numOfAccomodations
    const addonsDeltaAfterTax = addonToCalcBy[addondPropsAfterTax[paxProp]] * paxDelta * numOfAddons / numOfAccomodations

    reservation.ReservationDailyAddons.forEach(addon => {
        addon.ComputedTotalAfterTax += addonToCalcBy[addondPropsAfterTax[paxProp]] * paxDelta
        addon.ComputedTotalBeforeTax += addonToCalcBy[addondPropsBeforeTax[paxProp]] * paxDelta
    })

    //fixed by night (2) or fixed total (3)
    if ((reservation.ReservationPricingTypeId === 2 || reservation.ReservationPricingTypeId === 3) && reservation.ReservationDailyAccommodations) {
        reservation.ReservationDailyAccommodations.forEach(accomodation => {
            if (!accomodation.IsDeleted) {
                const IsBeforeTax = accomodation.Amount == accomodation.AmountBeforeTax;
                accomodation.Amount = IsBeforeTax ? accomodation.Amount - addonsDeltaBeforeTax : accomodation.Amount - addonsDeltaAfterTax;
                accomodation.AmountBeforeTax = accomodation.AmountBeforeTax - addonsDeltaBeforeTax
                accomodation.AmountAfterTax = accomodation.AmountAfterTax - addonsDeltaAfterTax
            }
        }) 
    }
}

// Cleans properties that should not be sent to server when saving reservation
export const CleanReservationProps = reservation=>{
    const result = _.omitBy(reservation, (value, key)=>{
        return  ['Color', 'Company', 'RoomType', 'Product', 'Room', 'Wing'].includes(key) ||
        key.startsWith('DayAmounts') || 
        (key === 'Guest' && value && value.Id !== 0 && !value.Updated)
    })
    if (result.ReservationDailyAccommodations) {
        result.ReservationDailyAccommodations = result.ReservationDailyAccommodations.map(accomodation=>{
            return _.omitBy(accomodation, (value, key)=>{
                return  ['Product', 'Rate', 'Room', 'RoomType', 'Wing'].includes(key)
            })
        })
    }
    result.IsDayUse = moment(reservation.CheckInDate).isSame(reservation.CheckOutDate, "day")
    return result  
}

export const GetSingleReservation = async ({Id, HotelId}) => {
    const reservations = await Calendar.GetReservations({
        Id,
        HotelId,
        includes: [
          'Room',
          'Status',
          'RoomType',
          'ReservationDailyAccommodations',
          'ReservationDailyAddons',
        ],
      });
    return reservations.length?reservations[0]:null
}